module.exports = __webpack_public_path__ + "src/img/zalando/img-iphones-orders.ad957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-iphones-orders.jpg
// module id = 123
// module chunks = 0